const { rethrow, getTokenFromStorage } = require('./utils');

module.exports = client => {
  const token = getTokenFromStorage();

  // TODO: Do this via redux middleware.
  if (token) {
    client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  }

  const setToken = response => {
    const { token } = response;
    client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    return response;
  };

  // ---
  // Authentication.
  // ---
  const login = data =>
    client.post('/auth/login', data).then(setToken, rethrow);
  const verify = data =>
    client.post('/auth/verify', data).then(setToken, rethrow);
  const logout = () => client.post('/auth/logout');
  const authSocket = data => client.post('/auth/analytics', data);

  // ---
  // Profile.
  // ---
  const profile = data => client.get(`/user/profile/${data.id}`, data);

  // ---
  // Cart.
  // ---
  const cartByUserID = ({ id }) => client.get(`/user/cart/${id}`);
  const deleteCartItem = data => client.post('/cart/items/delete', data);
  const addCartItem = data => client.post('/cart/items/add', data);
  const updateCartItem = data => client.post('cart/items/update', data);

  // ---
  // Order.
  // ---
  const order = data => client.post('/order/create', data);
  const orderStatus = data => client.get(`/order/${data.order_id}`);
  const payOrder = data => client.post(`/order/${data.order_id}/pay`, data);

  return {
    login,
    logout,
    profile,
    verify,
    cartByUserID,
    addCartItem,
    deleteCartItem,
    updateCartItem,
    order,
    orderStatus,
    authSocket,
    payOrder,
  };
};



// WEBPACK FOOTER //
// ../shared/optilit-http-client/src/api.js